export default "__VITE_ASSET__DqAf4BFk__"